import type { ReactNode } from 'react';
import { Result } from 'antd';
import { Can } from '../ability/AbilityContext';
import type { Action, Subject } from '../ability/superadmin';

/**
 * 403 page shown when the signed-in role fails a route's CASL gate — e.g. a
 * `super_admin_readonly` user hitting a create/edit route. Exported so the
 * App.tsx route table (Task 16) can drop its local copy and share this one.
 */
export function AccessDenied() {
  return (
    <Result
      status="403"
      title="Access denied"
      subTitle="Your role does not permit access to this resource."
    />
  );
}

/**
 * Route-level CASL guard. Collapses the repeated
 *   <Can I=… a=… passThrough>{(allowed) => allowed ? <Page/> : <AccessDenied/>}</Can>
 * boilerplate into one element, so route registration is a single line each.
 */
export function RequireCan({
  I,
  a,
  children,
}: {
  I: Action;
  a: Subject;
  children: ReactNode;
}) {
  return (
    <Can I={I} a={a} passThrough>
      {(allowed: boolean) => (allowed ? <>{children}</> : <AccessDenied />)}
    </Can>
  );
}
